import React from 'react'

const Section0 = () => {
    return (<>
        <section id="top" className="kv">
          <a href="https://www.identity-v.com/" className="logo" target="_blank" rel="noreferrer">第五人格</a>
          <div className="inner_wrap">
              <h1 className="title wow fadeInUp">三週年狂歡盛典 系列活動</h1>
              <p className="event_word wow fadeInUp" data-wow-delay="0.3s">
                  《第五人格》三週年生日快樂！<br />
                  精心準備的週年慶系列活動和感恩福利火熱展開，邀請偵探們一同蒞臨歐利蒂斯莊園，並在歡樂的氛圍中加入盛典狂歡、同慶三週年！
              </p>
              <span className="btn_video"></span>
          </div>
        </section>
        </>)
}

export default Section0
